import * as signalR from "@microsoft/signalr";
window.signalRCore = signalR;
